import type { BuyQuoteRequest, MarketPropertyQuery } from '../types/tradingTypes'

// Query keys factory for the secondary-market data layer (investor-service
// `/api/marketplace`). Hierarchical so a trade can invalidate whole trees.
export const tradingKeys = {
  all: ['trading'] as const,
  // Grid of tradable properties (browse), one entry per search/filter/sort.
  propertyLists: () => [...tradingKeys.all, 'propertyList'] as const,
  propertyList: (query: MarketPropertyQuery) => [...tradingKeys.propertyLists(), query] as const,
  properties: () => [...tradingKeys.all, 'property'] as const,
  property: (id: string) => [...tradingKeys.properties(), id] as const,
  sellerListings: () => [...tradingKeys.all, 'sellerListings'] as const,
  sellerListingsFor: (propertyId: string) => [...tradingKeys.sellerListings(), propertyId] as const,
  sellerListing: (listingId: string) =>
    [...tradingKeys.sellerListings(), 'one', listingId] as const,
  buyQuotes: () => [...tradingKeys.all, 'buyQuote'] as const,
  buyQuote: (listingId: string, request: BuyQuoteRequest) =>
    [...tradingKeys.buyQuotes(), listingId, request] as const,
  orders: () => [...tradingKeys.all, 'orders'] as const,
  order: (orderId: string) => [...tradingKeys.orders(), orderId] as const,
  myListings: () => [...tradingKeys.all, 'myListings'] as const,
  myListing: (listingId: string) => [...tradingKeys.myListings(), listingId] as const,
  holdings: () => [...tradingKeys.all, 'holding'] as const,
  sellOverview: (propertyId: string) => [...tradingKeys.holdings(), propertyId] as const,
  sellQuote: (propertyId: string, tokens: number, pricePerToken: number) =>
    [...tradingKeys.holdings(), propertyId, 'quote', tokens, pricePerToken] as const,
}
